import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomerProjectPhase } from '../../../customer-project-phase.interface';
import { CustomerProject } from '../../../customer-project.interface';
import { ConfirmDialogService } from '../../../services/confirm-dialog-service/confirm-dialog.service';
import { CustomerProjectPhaseService } from '../../../services/customer-project/customer-project-phase.service';

@Component({
    selector: 'app-customer-project-phase-edit-dialog',
    templateUrl: './customer-project-phase-edit-dialog.component.html',
    standalone: false,
})
export class CustomerProjectPhaseEditDialogComponent implements OnInit {
    form: FormGroup;
    fc: {
        id: FormControl;
        name: FormControl;
        start_date: FormControl;
        end_date: FormControl;
        customer_project_id: FormControl;
    };

    saving = false;

    constructor(
        private dialog: MatDialogRef<CustomerProjectPhaseEditDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public projectPhase: CustomerProjectPhase,
        private confirmDialog: ConfirmDialogService,
        private customerProjectPhasesService: CustomerProjectPhaseService
    ) {}

    ngOnInit(): void {
        this.fc = {
            id: new FormControl(this.projectPhase.id),
            name: new FormControl(this.projectPhase.name, Validators.required),
            start_date: new FormControl(this.projectPhase.start_date),
            end_date: new FormControl(this.projectPhase.end_date),
            customer_project_id: new FormControl(this.projectPhase.customer_project_id),
        };
        this.form = new FormGroup(this.fc);
    }

    delete() {
        this.confirmDialog
            .confirm(
                'Verwijderen',
                `Weet je zeker dat je de fase <b>${this.projectPhase.name}</b> met
            <b>${this.projectPhase.customer_project_phase_activities.length} activiteiten</b>
            en <b>${this.projectPhase.customer_project_phase_replies.length} reacties</b>
            wilt verwijderen?`,
                'Verwijderen',
                'Behouden'
            )
            .then(() =>
                this.customerProjectPhasesService.deletePhase(this.projectPhase.id).subscribe(result => {
                    Object.assign(this.projectPhase, result.data);
                    this.dialog.close(this.projectPhase);
                })
            )
            .catch(() => {});
    }

    setActive() {
        this.saving = true;
        this.customerProjectPhasesService
            .setActive(this.projectPhase.customer_project_id, this.projectPhase.id)
            .subscribe(data => {
                this.dialog.close(data.data as CustomerProject);
                this.saving = false;
            });
    }

    isDone(done: boolean) {
        this.saving = true;
        this.customerProjectPhasesService.setDone(this.projectPhase.id, done).subscribe(
            result => {
                Object.assign(this.projectPhase, result.data);
                this.dialog.close(this.projectPhase);
                this.saving = false;
            },
            () => (this.saving = false)
        );
    }

    save() {
        this.saving = true;
        this.customerProjectPhasesService.savePhase(this.form.value).subscribe(
            result => {
                Object.assign(this.projectPhase, result.data);
                this.dialog.close(this.projectPhase);
                this.saving = false;
            },
            () => (this.saving = false)
        );
    }
}
